// extracted by mini-css-extract-plugin
export default {"page":"StatsDetail_page__Nmq6o","errorCard":"StatsDetail_errorCard__t+1RM"};